import * as React from 'react';

import styles from './visual-pipeline-column-placeholder.module.css';

export class VisualPipelineColumnPlaceholder extends React.Component<Record<any, any>> {
    render() {
        return (
            <div className={styles.container}>
                <div className={styles['container-inner']} />
            </div>
        );
    }
}
